module.exports = __webpack_public_path__ + "static/media/hero-fighting.0dfc3409.png";